import { requestGet, requestPost } from '../../common/request/index';
class Apis {
  // 获得角色组管理接口
  getRolelist = async () => {
    return await requestGet('/role/list');
  };

  // 人员管理查询接口
  getUserRole = async (query) => {
    return await requestGet('/user/getRole', query);
  };

  // 人员配置查询接口
  getErp = async (query) => {
    return await requestGet('/role/getErp', query);
  };

  // 人员配置删除接口
  delErp = async (query) => {
    return await requestGet('/role/delErp ', query);
  };

  delRole = async (query) => {
    return await requestGet('/user/delRole', query);
  };

  // 人员配置增加接口
  addErp = async (query) => {
    return await requestGet('/role/addErp', query);
  };

  // 审核流列表http://10.170.131.196/mock/5ed46ed3393ecd00365fca1a/acore/resource/list
  getResourcelist = async (query) => {
    return await requestGet('/resource/list', query);
  };

  // 审核流查询接口http://10.170.131.196/mock/5ed46ed3393ecd00365fca1a/acore/resource/getErp
  getResourceErp = async (query) => {
    return await requestGet('/resource/getErp', query);
  };

  // 资源配置查询接口
  getResourceDirectErp = async (query) => {
    return await requestGet('/resourceDirect/getErp', query);
  };

  // 资源配置添加接口
  addResourcDirectErp = async (query) => {
    return await requestGet('/resourceDirect/addErp', query);
  };

  // 资源配置删除接口
  delResourceDirectErp = async (query) => {
    return await requestGet('/resourceDirect/delErp', query);
  };

  // 审核流添加接口
  addResourceErp = async (query) => {
    return await requestGet('/resource/addErp', query);
  };

  // 审核流删除接口
  delResourceErp = async (query) => {
    return await requestGet('/resource/delErp', query);
  };

  // 资源维护查询接口
  getResourceMaintain = async (query) => {
    // return await requestGet('/resourceMaintain/getErp', query)
    return await requestGet('/resourceMaintain/getErp', query);
  };

  // 资源维护添加接口
  addResourceMaintain = async (query) => {
    // return await requestGet('/resourceMaintain/addErp', query)
    return await requestGet('/resourceMaintain/addErp', query);
  };

  // 资源维护删除接口
  delResourceMaintain = async (query) => {
    // return await requestGet('/resourceMaintain/delErp', query)
    return await requestGet('/resourceMaintain/delErp', query);
  };

  // 资源位列表接口
  getResourceState = async (query) => {
    return await requestGet('/resourceState/query', query);
  };

  // 根据资源位详情查看接口
  getResourceStateDetail = async (query) => {
    return await requestGet('/resourceState/getByResourceStateCode', query);
  };

  // 修改资源位信息接口
  updateResourceState = async (query) => {
    Object.keys(query).forEach((key) => query[key] == null && (query[key] = ''));
    return await requestPost(
      '/resourceState/update',
      Object.entries(query)
        .reduce((prev, cur) => {
          return prev + '&' + cur[0] + '=' + encodeURIComponent(cur[1]);
        }, '')
        .slice(1)
    );
  };

  // 新增资源位信息接口
  createResourceState = async (query) => {
    Object.keys(query).forEach((key) => query[key] == null && (query[key] = ''));
    return await requestPost(
      '/resourceState/create',
      Object.entries(query)
        .reduce((prev, cur) => {
          return prev + '&' + cur[0] + '=' + encodeURIComponent(cur[1]);
        }, '')
        .slice(1)
    );
  };

  // 商家帮助中心-列表查询
  shopHelpList = async (query) => {
    return await requestGet('/shopHelp/list', query);
  };

  // 商家帮助中心-文档详情
  shopHelpInfo = async (query) => {
    return await requestGet('/shopHelp/info', query);
  };

  // 商家帮助中心-新增文档
  shopHelpAdd = async (query) => {
    return await requestPost('/shopHelp/add', query);
  };

  // 商家帮助中心-编辑文档
  shopHelpEdit = async (query) => {
    return await requestPost('/shopHelp/edit', query);
  };

  // 商家帮助中心-删除文档
  shopHelpDel = async (query) => {
    return await requestGet('/shopHelp/del', query);
  };

  // 商家帮助中心-启用状态变更
  shopHelpUpdateStatus = async (query) => {
    return await requestGet('/shopHelp/updateStatus', query);
  };

  // 商家帮助中心-置顶状态变更
  shopHelpUpdateTop = async (query) => {
    return await requestGet('/shopHelp/updateTop', query);
  };

  fileUpload = async (query) => {
    return await requestPost('/oss/file/upload?module=1', query);
  };

  // 图片上传
  uploadPic = async (query) => {
    return await requestPost('/file/uploadFile', query);
  };

  // 文件上传
  uploadFile = async (query) => {
    return await requestPost('/oss/file/upload?module=1', query);
  };

  marketAuthList = async (query) => {
    return await requestGet('/market/auth/list', query);
  };

  marketAuthDel = async (query) => {
    return await requestGet('/market/auth/del', query);
  };
  marketAuthAdd = async (query) => {
    return await requestGet('/market/auth/add', query);
  };
  marketAuthGet = async (query) => {
    return await requestGet('/market/auth/get', query);
  };
  async marketAuthUpdate(query) {
    return await requestGet('/market/auth/update', query);
  }

  // 重要通知接口
  async dripGenericActcenterBizNotifyList(query) {
    return await requestPost('/dripGeneric/actcenter/bizNotify/list', query);
  }
  async dripGenericActcenterBizNotifyDel(query) {
    return await requestPost('/dripGeneric/actcenter/bizNotify/del', query);
  }
  async dripGenericActcenterBizNotifyAdd(query) {
    return await requestPost('/dripGeneric/actcenter/bizNotify/add', query);
  }
  async dripGenericActcenterBizNotifyUpdate(query) {
    return await requestPost('/dripGeneric/actcenter/bizNotify/update', query);
  }

  //类目流量场配置接口
  async cateManageTree(query) {
    return await requestGet('/cateManage/tree', query);
  }
  async cateManageRelate(query) {
    return await requestPost('/cateManage/relate', query);
  }
}

export default new Apis();
